var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"stepsCard",staticClass:"steps-box"},_vm._l((_vm.stepsData),function(item,index){return _c('div',{key:index,class:[_vm.width == '270' ? 'steps-card' : 'steps-card2',index <= _vm.stepsIndex ? 'on' : '']},[_c('span',[_vm._v(_vm._s(index + 1))]),_c('span',[_vm._v(_vm._s(item.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }